import Vue from 'vue'

import Avatar from './Avatar.vue'
import Button from './Button.vue'
import Dropdown from './Dropdown.vue'
import Radio from './Radio.vue'
import TextInput from './TextInput.vue'
import GradientImage from './GradientImage.vue'

const Components = {
  Avatar,
  Button,
  Dropdown,
  Radio,
  TextInput,
  GradientImage
}

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name])
})

export default Components
